import { useNavigate } from "external/react"

import { notifySuccess, showConfirmDialog } from "components/Notify"

import usePayment from "context/payment-context/hook"

export default function RemovePackage() {

    const {emptyCart} = usePayment()
    const navigate = useNavigate()

    async function handleClick() {
        const {isConfirmed} = await showConfirmDialog('¿Desea vaciar el carrito?')
        if (!isConfirmed) return
        await emptyCart()
        notifySuccess('Se vació el carrito.')
		navigate('/offers')
    }

    return (
        <button className='btn btn-danger py-0' onClick={handleClick}>Eliminar</button>
    )
}